export const timeStamp = (dateObj) => {
  let date = new Date();
  if (dateObj !== null && dateObj !== undefined) {
    date = new Date(dateObj);
  }
  return date.toISOString().split("T")[0] + " " + date.toTimeString().split(" ")[0];
};
